import React from "react";
import facebookIcon from "../assets/social-icon/facebook.svg";
import instagramIcon from "../assets/social-icon/ig.svg";
import googleIcon from "../assets/social-icon/google.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-icons">
          <a
            href="https://www.facebook.com/artparis.total.look/?ref=hl"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon"
          >
            <img src={facebookIcon} alt="Facebook" className="footer-icon" />
          </a>
          <a
            href="https://www.instagram.com/artparis_total_look_rome/?utm_medium=copy_link"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon"
          >
            <img src={instagramIcon} alt="Instagram" className="footer-icon" />
          </a>
          <a
            href="https://www.google.com/maps/place/Art+Paris+Snc/@41.9825321,12.5101876,16z/data=!4m22!1m13!4m12!1m4!2m2!1d12.5223565!2d41.9808693!4e1!1m6!1m2!1s0x132f6689fce8f2b1:0x9aadcf62af62aed7!2sArt+Paris+Snc+Recensioni!2m2!1d12.5127625!2d41.9825281!3m7!1s0x132f6689fce8f2b1:0x9aadcf62af62aed7!8m2!3d41.9825281!4d12.5127625!9m1!1b1!16s%2Fg%2F1tdj6c0_?entry=ttu"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon"
          >
            <img src={googleIcon} alt="Google" className="footer-icon" />
          </a>
        </div>

        <div className="footer-text">
          <p className="footer-copyright">© 2026 Art Paris - Total look · Tutti i diritti riservati</p>
          {/* <p className="footer-credits">
            Sviluppato da <span className="footer-credits-name">Sara Ferrantini</span>
          </p> */}
        </div>

        {/* colonna vuota per bilanciare la griglia (al posto di "Area Admin") */}
        <div className="footer-spacer" />
      </div>
    </footer>
  );
};

export default Footer;
